export enum SearchTypeEnum {
  teachings = "teachings",
  studyPlans = "studyPlans"
}
